import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { ref } from 'vue';
import type { UserDataset } from '../types';
import NewDataGenericAggregation from './DataFoldingAndBinning.vue';

interface DataAggregationProps {
  selection: UserDataset | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AdvancedOperations',
  props: /*@__PURE__*/_mergeModels({
    selection: {}
  }, {
    "modelValue": { type: Boolean, ...{ type: Boolean, required: true } },
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["save"], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {


const dialogOpen = _useModel<boolean>(__props, 'modelValue');


const mode = ref<'aggregate' | 'fold' | 'new'>('new');

const emit = __emit;

// Save the aggregation
// function saveAggregation(selection: UserDataset) {
//   emit('save', selection);
// }

function saveFolded(selection: UserDataset) {
  // Reuse same save channel for folded selections
  emit('save', selection);
}




return (_ctx: any,_cache: any) => {
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialogOpen.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogOpen).value = $event)),
    "max-width": "90vw",
    "max-height": "90vh",
    persistent: "",
    scrollable: ""
  }, {
    default: _withCtx(() => [
      (mode.value === 'new')
        ? (_openBlock(), _createBlock(NewDataGenericAggregation, {
            key: 0,
            modelValue: dialogOpen.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogOpen).value = $event)),
            selection: __props.selection,
            onSave: saveFolded
          }, null, 8, ["modelValue", "selection"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})